export const FETCH_OWCS_SUCCESS = "FETCH_OWCS_SUCCESS";
export const FETCH_OWCS_FAILED = "FETCH_OWCS_FAILED";

